import React from "react";
import Chart from "react-apexcharts";

const VendorTopCustomersChart = ({ topCustomers = [] }) => {
  // Ensure minimum 3 items
  const filledCustomers = [...topCustomers];

  while (filledCustomers.length < 3) {
    filledCustomers.push({
      user_id: null,
      name: "N/A",
      total_orders: 0,
    });
  }

  const chartOptions = {
    chart: {
      type: "bar",
      toolbar: { show: false },
    },
    xaxis: {
      categories: filledCustomers.map((c) => c.name),
    },
    dataLabels: {
      enabled: false,
    },
    plotOptions: {
      bar: {
        borderRadius: 4,
        columnWidth: "50%",
      },
    },
  };

  const chartSeries = [
    {
      name: "Total Orders",
      data: filledCustomers.map((c) => Number(c.total_orders)),
    },
  ];

  return (
    <div className="card p-3">
      <h5 className="mb-3">Top Customers</h5>
      <Chart
        options={chartOptions}
        series={chartSeries}
        type="bar"
        height={300}
      />
    </div>
  );
};

export default VendorTopCustomersChart;
